import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import {
  NotificationsService,
  type ToastTone,
} from '../../../core/notifications/notifications.service';

const TONE_CLASSES: Record<ToastTone, string> = {
  info: 'bg-status-info/10 text-text-primary border-status-info/30',
  success: 'bg-status-success/10 text-text-primary border-status-success/30',
  warning: 'bg-status-warning/10 text-text-primary border-status-warning/30',
  error: 'bg-status-danger/10 text-text-primary border-status-danger/30',
};

@Component({
  selector: 'g-toast-host',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      class="pointer-events-none fixed inset-x-4 top-4 z-[100] flex flex-col gap-2 md:left-auto md:right-4 md:w-96"
      aria-live="polite"
      aria-atomic="false"
    >
      @for (toast of notifications.queue(); track toast.id) {
        <div
          [class]="
            'pointer-events-auto animate-toast-in rounded-lg border px-4 py-3 shadow-lg text-sm flex items-start gap-3 backdrop-blur-sm ' +
            toneClass(toast.tone)
          "
          role="status"
        >
          <div class="flex-1">
            @if (toast.title) {
              <p class="font-semibold">{{ toast.title }}</p>
            }
            <p [class.mt-0.5]="!!toast.title">{{ toast.message }}</p>
          </div>
          <button
            type="button"
            class="text-text-muted hover:text-text-primary"
            aria-label="Dismiss"
            (click)="notifications.dismiss(toast.id)"
          >
            ×
          </button>
        </div>
      }
    </div>
  `,
})
export class ToastHostComponent {
  protected readonly notifications = inject(NotificationsService);

  protected toneClass(tone: ToastTone): string {
    return TONE_CLASSES[tone];
  }
}
